import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import downloadIcon from "../assets/icons/download.svg";
import { Trans } from "react-i18next";
import installImage from "../assets/image/installationGuide/install.png";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const InstallationGuide = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-03";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        const strip = (key) =>
            t(key).replace(/<[^>]+>/g, "").trim();

        return `
${t("sidebar.install.title")}

${t("installationGuide.operatingsystemrequire")}
- ${t("installationGuide.operatingsystem")}
- ${t("installationGuide.adminstrator")}
- ${t("installationGuide.internet")}

${t("installationGuide.step")}

1. ${strip("installationGuide.step1")}
   https://agent.quantera.vn/

2. ${strip("installationGuide.step2")}
   - ${t("installationGuide.step2a")}
   - ${t("installationGuide.step2b")}

3. ${strip("installationGuide.step3")}
  `.trim();
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          max-w-3xl
        "
            >
                <div className="
  relative flex items-center justify-between gap-3
  mobile:flex-col
  mobile:items-stretch
  desktop:flex-row-reverse
  tabletpro:flex-row-reverse
  tabletair:flex-row-reverse
  tabletmini:flex-row-reverse
  mini_mobile:flex-col mini_mobile:items-stretch
">
                    {/* Copy button */}
                    <div className="mobile:flex mobile:justify-end mobile:order-1 mini_mobile:flex mini_mobile:justify-end">
                        <CopyButton text={buildCopyText(t)} />
                    </div>

                    {/* Icon + text */}
                    <div className="flex items-center gap-1 mobile:order-2">
                        <img
                            src={downloadIcon}
                            alt="download"
                            className="w-9 h-16 mobile:w-9 mobile:h-9"
                        />
                        <p className="text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[28px] mobile:text-[28px] mini_mobile:text-[24px] font-semibold">
                            {t("sidebar.install.title")}
                        </p>
                    </div>
                </div>


                <div className="mt-2 relative">
                    <section className='flex flex-col gap-4 mt-1'>
                        <p className='text-[16px] font-semibold text-[#0F172A] dark:text-[#F1F5F9]'>{t("installationGuide.operatingsystemrequire")}</p>
                        <ul className="list-disc pl-10 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("installationGuide.operatingsystem")}
                            </li>

                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("installationGuide.adminstrator")}
                            </li>

                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("installationGuide.internet")}
                            </li>
                        </ul>
                        <p className='text-[16px] font-semibold text-[#0F172A] dark:text-[#F1F5F9]'>{t("installationGuide.step")}</p>
                        <div className="pl-6 space-y-2">
                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="installationGuide.step1"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                                {" "}
                                <a
                                    href="https://agent.quantera.vn/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                                >
                                    https://agent.quantera.vn/
                                </a>
                            </p>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="installationGuide.step2"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <ul className="list-disc pl-6 space-y-1">
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGuide.step2a")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGuide.step2b")}
                                </li>
                            </ul>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGuide.step3"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>
                        </div>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: installImage
                        }}>
                            <img
                                src={installImage}
                                alt="Installation Guide"
                                className="w-full cursor-zoom-in"
                            />
                        </Zoom>

                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.version")}
                            to="/version"
                        />
                        <NextSectionCard
                            label={t("sidebar.install.itemInstall")}
                            to="/install-gopaperlessagent"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default InstallationGuide